export default __webpack_public_path__ + "static/exklusivesangebot-4a286f9c80e5b2cb48948897b3e7ae26.jpg";